import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PublicTrackingEndpoint } from '../constants/public-tracking-endpoint';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { ItemTrackingContentType, PublicTrackingItemModel } from '../models/public-tracking.model';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { OPEN_INFO_API_URL } from '../../../../services/config';
import { RequestHeader } from '../../../constants';

@Injectable({
  providedIn: 'root',
})
export class PublicTrackingItemService {
  constructor(private http: WrapperHttpService) {}

  getItem({
    itemId,
    zipCode,
    trackingContentType,
    sapId,
  }: {
    itemId: string;
    zipCode?: string;
    trackingContentType?: ItemTrackingContentType | string;
    sapId?: string;
  }): Observable<PublicTrackingItemModel> {
    const url = `${OPEN_INFO_API_URL}${PublicTrackingEndpoint.Base}?${PublicTrackingEndpoint.RequestNumber}=${itemId}`;

    let params = new HttpParams();

    switch (true) {
      case !!sapId && !!trackingContentType:
        params = params.append('sapId', sapId);
        params = params.append('trackingContentType', trackingContentType);
        break;
      case !!zipCode && !!trackingContentType:
        params = params.append('zipCode', zipCode);
        params = params.append('trackingContentType', trackingContentType);
        break;
      case !!zipCode:
        params = params.append('zipCode', zipCode);
        break;
      case !!trackingContentType:
        params = params.append('trackingContentType', trackingContentType);
        break;
    }

    return this.http.withLoading().get<PublicTrackingItemModel>(url, {
      params,
      headers: new HttpHeaders({
        [RequestHeader.SkipInterceptor]: '',
      }),
    });
  }
}
